module.exports = __webpack_public_path__ + "media/images/black_history_month/our_south-da6a5209473855adaba1d87b663adb3e.png";